import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { useMedia } from "../../../../hooks/useMedia";

import { Accordion } from "../../../../components/Accordion";
import PaymentCard from "../../../../components/PaymentCard";
import Table from "../../../../components/Table";
import FinalizedProposal from "../FinalizedProposal";
import Loader from "../Loader";

import "./index.scss";
import { useState } from "react";

const tableHeaders = [
  "Tipo",
  "Número",
  "Referência",
  "Item",
  "Data de emissão",
  "Data de vencimento",
  "Exercício",
  "Valor principal",
  // "Valor atualizado",
];

const tableObejctKeys = [
  "doc_type",
  "doc_number",
  "reference",
  "item",
  "release_date",
  "due_date",
  "exercise",
  "value",
  // "refreshed_value",
];

function ChargeHome({
  handleChangeStep,
  isLoadingProposals = false,
  isLoadingList = false,
}) {
  const {
    debtInfo,
    activeProposals,
    payment,
    archivedProposals,
    // unpaidProposals,
  } = useSelector((state) => state.charge);

  const dispatch = useDispatch();
  const isMobile = useMedia("(max-width: 960px)");
  const [showLoader, setShowLoader] = useState(true);

  const proposalIsActive =
    debtInfo.status === "NEGOTIATION" || debtInfo.status === "PAID";
  let totalWithFees = 0;

  if (activeProposals.length > 0) {
    totalWithFees =
      activeProposals.length *
      activeProposals[activeProposals.length - 1].value;
  }

  function handleGoToConfirmation(type) {
    dispatch({ type: "CHANGE_FLOW", payload: "payment" });
    dispatch({ type: "CHANGE_PREVIOUS_STEP", payload: 1 });

    if (type === "credit") {
      const payload = {
        paymentType: type,
      };

      dispatch({ type: "CHANGE_PAYMENT", payload });
      handleChangeStep(2);
    } else {
      const payload = {
        paymentType: type,
        total: activeProposals[0]?.value,
        interestRate: activeProposals[0]?.interest_rate,
        proposalId: activeProposals[0]?.id,
      };

      dispatch({ type: "CHANGE_PAYMENT", payload });
      handleChangeStep(3);
    }
  }

  // function handleRejectProposal() {
  //   handleChangeStep(6)
  // }

  function returnClassName() {
    let className = "charge-home";

    if (!proposalIsActive) {
      className += " charge-home--rejected-proposal";
    }

    return className;
  }

  function returnTitle(status) {
    switch (status) {
      case "SENT":
        return "Como você gostaria de pagar?";
      case "NEGOTIATION":
        return "Em negociação";
      case "WAITING_APPROVAL":
        return "Aguardando assinatura da minuta";
      case "PAID":
        return "Proposta concluída";
      case "ARCHIVED":
        return "Proposta Arquivada";
      case "WAITING":
        return "Aguardando assinatura e pagamento";
      case "CLOSED":
        return "Encerrado";
      case 'CHAT NEGOTIATION':
        return "Em negociação por chat";
      default:
        return "Aguardando pagamento";
    }
  }

  function renderCards() {
    // if (isLoading) {
    //   return (
    //     <div className="charge-home__cards">
    //       <PaymentCard
    //         type="toSelect"
    //         isLoading={isLoading}
    //         minHeight="150px"
    //       />
    //       <PaymentCard
    //         type="toSelect"
    //         isLoading={isLoading}
    //         minHeight="150px"
    //       />
    //     </div>
    //   );
    // }
    if (debtInfo.status === "NEGOTIATION") {
      return (
        <div className="charge-home__cards">
          <PaymentCard
            type="toSelect"
            typePayment="À vista"
            way="Boleto bancário"
            total={activeProposals[0]?.value}
            interestRate={activeProposals[0]?.interest_rate}
            withButton={proposalIsActive}
            minHeight={proposalIsActive ? "201px" : "150px"}
            handleClick={() => handleGoToConfirmation("cash")}
          />
          <PaymentCard
            type="toSelect"
            typePayment="Parcelado"
            way="Boleto bancário"
            total={totalWithFees}
            entry={0}
            numberInstallments={activeProposals.length}
            valueInstallments={
              activeProposals[activeProposals.length - 1]?.value
            }
            withButton={proposalIsActive}
            minHeight={proposalIsActive ? "201px" : "150px"}
            handleClick={() => handleGoToConfirmation("credit")}
          />
        </div>
      );
    }

    if (debtInfo.status === "PAID") {
      const { numberInstallments, valueInstallments } = payment;
      if (numberInstallments === 1) {
        return (
          <div className="charge-home__cards" style={{ maxWidth: "50%" }}>
            <PaymentCard
              type="toSelect"
              typePayment="À vista"
              way="Boleto bancário"
              total={valueInstallments}
              minHeight={proposalIsActive ? "201px" : "150px"}
              handleClick={() => handleGoToConfirmation("cash")}
            />
          </div>
        );
      } else {
        let lastInstallmentValue = Number(valueInstallments);
        let totalWithFees = numberInstallments * valueInstallments;

        return (
          <div className="charge-home__cards" style={{ maxWidth: "50%" }}>
            <PaymentCard
              type="toSelect"
              typePayment="Parcelado"
              way="Boleto bancário"
              total={totalWithFees}
              entry={lastInstallmentValue}
              numberInstallments={numberInstallments}
              valueInstallments={lastInstallmentValue}
              minHeight={proposalIsActive ? "201px" : "150px"}
              handleClick={() => handleGoToConfirmation("credit")}
            />
          </div>
        );
      }
    }
  }
  
  if (showLoader || debtInfo.status === "SENT") {
    return (
      <Loader
        proposalIsActive={proposalIsActive}
        isLoading={isLoadingProposals}
        closeLoader={() => setShowLoader(false)}
      />
    );
  } else {
    return (
      <section className={returnClassName()}>
        <div className="charge-home__title">
          <h2>{returnTitle(debtInfo.status)}</h2>
        </div>
        {renderCards()}

        {debtInfo.status !== "PAID" && !_.isEmpty(archivedProposals) && (
          <div className="charge-home__reject-accordion">
            <Accordion
              title="Propostas"
              wide={isMobile}
              open={!proposalIsActive}
            >
              <FinalizedProposal origin="debtor" />
            </Accordion>
            {/* {unpaidProposals && (
              <Accordion
                title="Propostas não pagas"
                wide={isMobile}
                open={!proposalIsActive}
              >
                <FinalizedProposal origin="debtor" unpaid={true} />
              </Accordion>
            )} */}
          </div>
        )}
        <Table
          titleTable="Natureza do débito"
          headers={tableHeaders}
          objectKeys={tableObejctKeys}
          items={debtInfo.debts}
        />
      </section>
    );
  }
}

export default ChargeHome;
